import { Analytics } from "@plaudit/analytics";
import type * as jQuery from 'jquery';
const $ = (window as any).jQuery as JQueryStatic;

export default function init() {
	const analytics = Analytics.getInstance();

	var forms = $(".mini-contact-form");
	var formSelects = forms.find('select');
	var ajaxPath = "assets/ajax/mini-contact.html";

	forms.off('submit.wait');
	forms.on('submit.mini', function(event){
		event.preventDefault();
		var $this = $(this);
		if ( $this.find('.fieldArea:first-child > select').val()!==null ) {
			$this.off('submit.mini').trigger('submit');
			analytics.trackEvent("Mini Contact", "Submit", $this.data('location')+' | '+document.location.href );
		} else {
			$this.find('input').val("Please select a region");
		}
	});

	// call the form generator to get the new select
	forms.on('change.first', '.fieldArea:first-child > select', function(evt){
		// Serializes form data.
		var data = $(this).serialize();

		// Updates both forms
		forms.load( ajaxPath+'?'+data+' .ajaxWrap' );
	});
}